import SwiperCore, { Autoplay, Pagination, EffectFade } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/swiper.min.css";
//import "swiper/components/pagination/pagination.min.css";

// Swiper styles (MANDATORY)
import "swiper/css";
import "swiper/css/pagination";

SwiperCore.use([Autoplay, Pagination]);

export type Slide = {
  id: number;
  title: string;
  subtitle?: string;
  image: string;
};

interface Props {
  slides: Slide[];
  width?: string;
  height?: string;
}

export default function HeroCarousel({ slides, width = "95%", height = "400px" }: Props) {
  if (!slides.length) return null;

  return (
    <div
      className="hero-carousel-container"
      style={{
        width,
        height,
        overflow: "hidden",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop
        speed={800} // controls slide animation speed
        className="hero-swiper h-100"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div
              className="hero-slide position-relative h-100 w-100"
              style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <img
                src={slide.image}
                alt={slide.title}
                className="w-100 h-100"
                style={{
                  objectFit: "cover",
                  transition: "transform 0.6s ease-in-out",
                }}
              />
              <div
                className="hero-overlay position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center text-white"
                style={{
                  background: "rgba(0,0,0,0.3)",
                  padding: "1rem",
                  textAlign: "center",
                }}
              >
                <h5 className="fw-bold animate__animated animate__fadeInDown">{slide.title}</h5>
                {slide.subtitle && (
                  <p className="small animate__animated animate__fadeInUp">{slide.subtitle}</p>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}



/*
import { useEffect, useRef } from "react";
import Swiper from "swiper";
import { Navigation, Pagination, Virtual, Autoplay } from "swiper/modules";
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

const slides = [
  "Welcome to Our Store",
  "Best Products, Best Prices",
  "Shop Smart Today",
  "Fast & Secure Checkout",
  "Quality You Can Trust",
];

const HeroCarousel = () => {
  const swiperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!swiperRef.current) return;

    const swiper = new Swiper(swiperRef.current, {
      modules: [Navigation, Pagination, Virtual, Autoplay],
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      virtual: {
        enabled: true,
        slides,
      },
    });

    return () => {
      swiper.destroy(true, true);
    };
  }, []);

  return (
    <div className="swiper w-full h-[400px]" ref={swiperRef}>
      <div className="swiper-wrapper">
        {// Virtual slides will be injected automatically }
      </div>

      <div className="swiper-pagination"></div>
      <div className="swiper-button-prev"></div>
      <div className="swiper-button-next"></div>
    </div>
  );
};

export default HeroCarousel;
*/
/*
import { useEffect, useState } from "react";

type Slide = {
  id: number;
  title: string;
  subtitle?: string;
  image: string;
};

interface Props {
  slides: Slide[];
}

export default function HeroCarousel({ slides }: Props) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [slides.length]);

  if (!slides.length) return null;

  return (
    <div className="position-relative overflow-hidden" style={{ height: 420 }}>
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          className={`position-absolute w-100 h-100 transition-opacity ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
          style={{ transition: "opacity 1s ease-in-out" }}
        >
          <img
            src={slide.image}
            alt={slide.title}
            loading="lazy"
            className="w-100 h-100 object-fit-cover"
          />
          <div className="position-absolute top-50 start-50 translate-middle text-white text-center">
            <h1 className="fw-bold">{slide.title}</h1>
            {slide.subtitle && <p>{slide.subtitle}</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
*/